var map = {
	"./96sdriver.webp": "4117",
	"./addidas_preview.webp": "a368",
	"./avataruniverse.webp": "3691",
	"./bonscheladen.webp": "8f03",
	"./cards.webp": "5257",
	"./cozy.webp": "4e90",
	"./dreamroom_preview.webp": "bbf9",
	"./drivehorizon.webp": "9c02",
	"./dynamicmaschines_preview.webp": "60fa",
	"./fakecorporate.webp": "734e",
	"./insta360.webp": "a6cf",
	"./journey.webp": "7ca3",
	"./mtstudio.webp": "e4c7",
	"./retroboy.webp": "3825",
	"./soundninja.webp": "e13b",
	"./spiral.webp": "a2e0",
	"./sunrise_preview.webp": "5c1d",
	"./treehouse.webp": "96d3",
	"./trianglecube.webp": "3888",
	"./voiscooter.webp": "9933"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9961";